import { createContext, useContext } from 'react';

export type ChatUnreadValue = {
  /** Unread messages per chatKey(). Threads with nothing unread are absent, not zero. */
  countByKey: Map<string, number>;
  /** Everything unread, everywhere -- what the nav badge shows. */
  total: number;
  refetch: () => void;
};

/**
 * Lives here rather than beside the provider so that file exports nothing but a
 * component: mixing a component and a hook in one module breaks React Fast Refresh
 * (react-refresh/only-export-components).
 *
 * The default is a real empty value, not undefined -- NavBar renders on screens that
 * are outside the provider in tests, and a badge of zero is the right answer there.
 */
export const ChatUnreadContext = createContext<ChatUnreadValue>({
  countByKey: new Map(),
  total: 0,
  refetch: () => {},
});

/** Unread counts for every conversation this viewer can see. */
export function useChatUnread(): ChatUnreadValue {
  return useContext(ChatUnreadContext);
}
